import ButtonBase, { ButtonBaseProps } from "@mui/material/ButtonBase";

interface UppercaseButtonProps
  extends Omit<ButtonBaseProps, "sx" | "children" | "color"> {
  children?: React.ReactNode;
  color: "primary" | "secondary";
}

const UppercaseButton: React.FC<UppercaseButtonProps> = ({
  children,
  color,
  disabled,
  ...rest
}) => {
  const disabledBackground = "#D0D1D3";
  const background = color === "primary" ? "#755FFA" : "#E3E1FF";
  const htmlColor = color === "primary" ? "#FFF" : "#755FFA";

  return (
    <ButtonBase
      disabled={disabled}
      {...rest}
      sx={{
        background: disabled ? disabledBackground : background,
        borderRadius: "20px",
        color: htmlColor,
        fontFamily: "Lato",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 700,
        minWidth: "200px",
        height: "32px",
        lineHeight: "normal",
        padding: "10px",
        textDecoration: "none",
        textTransform: "uppercase",
      }}
    >
      {children}
    </ButtonBase>
  );
};

export default UppercaseButton;
